import {PHASES} from "../../constants/phases";

export const isConstructionMarkersShown = (selectedToken, sharedGameState) => {
  return sharedGameState.phase === PHASES.CONSTRUCTION
    && !!selectedToken
}